/****************************************************
 * Module Name:  editBrokerModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import UserProxy from "../../utility/proxy/manager/userProxy";
import Select from "react-select";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import "bootstrap/dist/css/bootstrap.min.css";
import DesignationProxy from "../../utility/proxy/manager/designationProxy";
import { Box, Button, Checkbox, FormControlLabel, TextField, Tooltip, Typography, } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { MultiSelect } from "../common/reactSelectWithSelectAll";
import BrokerProxy from "../../utility/proxy/manager/brokerProxy";
import { LoadingButton } from "@mui/lab";
import SettingsProxy from "../../utility/proxy/manager/settingsProxy";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

const setPropSourceDataofCustomer = (dataToMap) => {
  let newArr = [];
  dataToMap.map((item) => {
    let option = { value: item.customerid, label: item.username };
    newArr.push(option);
    return true;
  });
  return newArr;
};

const setPropSourceDataofEmployee = (dataToMap) => {
  let newArr = [];
  dataToMap.map((item) => {
    let option = { value: item.employeid, label: item.username };
    newArr.push(option);
    return true;
  });
  return newArr;
};

const fullOptionToEmployeeValue = (brokerId, selectedData) => {
  let brokerid = brokerId;
  let newArr = [];
  selectedData.map((option) => {
    newArr.push({ brokerid, employeid: option.value });
    return true;
  });
  return newArr.includes("*") ? [] : newArr;
};

const fullOptionToCustomerValue = (brokerId, selectedData) => {
  let brokerid = brokerId;
  let newArr = [];
  selectedData.map((option) => {
    newArr.push({ brokerid, customerid: option.value });
    return true;
  });
  return newArr.includes("*") ? [] : newArr;
};

export default class EditBrokerModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newusername: this.props.editOperation
        ? this.props.sourceData.username
        : "",
      newUserType:
        this.props.sourceData !== undefined
          ? this.props.editOperation ||
            (!this.props.editOperation && this.props.sourceData.usertype)
            ? {
              value: this.props.sourceData.usertype,
              label: this.props.sourceData.usertype,
            }
            : { value: 0, label: "Error" }
          : { value: 0, label: "Error" },
      newfirst_name: this.props.editOperation
        ? this.props.sourceData.first_name
        : "",
      newmiddle_name: this.props.editOperation
        ? this.props.sourceData.middle_name
        : "",
      newlast_name: this.props.editOperation
        ? this.props.sourceData.last_name
        : "",
      newdesignation: this.props.editOperation
        ? this.props.sourceData.designation
        : "",
      newemployeeid: this.props.editOperation
        ? this.props.sourceData.employeeid
        : "",
      newlocationid: this.props.editOperation
        ? this.props.sourceData.locationid
        : "",
      newfullLocation: this.props.editOperation
        ? {
          value: this.props.sourceData.locationid,
          label: this.props.sourceData.location,
        }
        : { value: 0, label: "Error" },
      newAssignedEmployee: this.props.editOperation
        ? setPropSourceDataofEmployee(this.props.sourceData.employebrokerdtos)
        : "",
      newAssignedCustomer: this.props.editOperation
        ? setPropSourceDataofCustomer(this.props.sourceData.brokercustomerdtos)
        : "",
      newGrade: this.props.editOperation
        ? {
          value: this.props.sourceData.grade,
          label: this.props.sourceData.grade,
        }
        : { value: 0, label: "Error" },
      newDiscount: this.props.editOperation
        ? this.props.sourceData.discount
          ? this.props.sourceData.discount
          : "0.0"
        : "0.0",
      newCommission: this.props.editOperation
        ? this.props.sourceData.commission
          ? this.props.sourceData.commission
          : "0.0"
        : "0.0",
      newLabgrownDiscount: this.props.editOperation
        ? this.props.sourceData.labgrowndiscount
          ? this.props.sourceData.labgrowndiscount
          : "0.0"
        : "0.0",
      newLabGrownCommission: this.props.editOperation
        ? this.props.sourceData.labgrowncommission
          ? this.props.sourceData.labgrowncommission
          : "0.0"
        : "0.0",
      newGstNo: this.props.editOperation
        ? this.props.sourceData.gstinno
          ? this.props.sourceData.gstinno
          : ""
        : "",
      newPanNo: this.props.editOperation
        ? this.props.sourceData.panno
          ? this.props.sourceData.panno
          : ""
        : "",
      newdeleted: this.props.editOperation
        ? this.props.sourceData.deleted
        : false,
      newdisabled: this.props.editOperation
        ? this.props.sourceData.disabled
        : false,
      newspecialuser: this.props.editOperation
        ? this.props.sourceData.specialuser
        : false,
      newEmail: this.props.editOperation ? this.props.sourceData.email : "",
      newPhone: this.props.editOperation ? this.props.sourceData.phone : "",
      newCreated: this.props.editOperation ? this.props.sourceData.created : "",
      newCreatedBy: this.props.editOperation ? this.props.sourceData.createdby : Constants.loggedInUser.username,
      newCompanyName: this.props.editOperation ? this.props.sourceData.companyname : "",

      showError: false,

      discountTypes: "",
      settingKeys: [],
      commissionPremiumLimit: "0.0",
      commissionPremiumError: "",
      labgrownCommissionPremiumError: "",
      commissionLimit: "0.0",
      commissionError: "",
      labgrownCommissionError: "",

      validateUserPresentSpinner: false,
      showValidationMessage: false,
      userNameAvailable: true,

      fullLocation: [],
      fullLocationOptions: [],
      showLocationLoadSpinner: true,

      employeeOptions: [],
      showEmployeeLoadSpinner: true,

      customerOptions: [],
      showCustomerLoadSpinner: true,

      allUserType: [],
      allGrades: [],

      designationOptions: [],
      showDesignationLoadSpinner: true,

      userNameValidationError: "",
      firstNameValidationError: "",
      commissionValidationError: "",
      labgrownCommissionValidationError: "",
      newPanNoValidationError: "",

      customerInputValue: "",
      debouncedCustomerInputValue: "",

      showUserDetailModal: false,
      userDetailContext: ""
    };
    this.getAllLocationList();
    this.getAllDesignationList();
    this.getAllEmployee();
    this.getAllCustomer();
    this.getAllSettingKeys();
    if (this.props.sourceData === undefined) {
      this.getUserById();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.handleDebounce("customerInputValue", "debouncedCustomerInputValue", prevState, this.state);
  }

  handleDebounce(inputState, debouncedState, prevState, currentState) {
    if (prevState[inputState] !== currentState[inputState]) {
      this.setState({ [debouncedState]: currentState[inputState] });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.customerInputValueTimeoutId);
  }

  getFilteredUserOptions(debouncedValue) {
    if (!debouncedValue) {
      return this.state.customerOptions.slice(0, 100);
    }
    return this.state.customerOptions
      .filter(option =>
        option.label.toLowerCase().includes(debouncedValue.toLowerCase())
      )
      .slice(0, 500);
  }

  getAllSettingKeys = () => {
    let optionsArray = [];
    optionsArray.push("MAX_CUSTOMER_DISCOUNT");
    optionsArray.push("MAX_CUSTOMER_PREMIUM");
    optionsArray.push("MAX_BROKER_COMMISSION");
    optionsArray.push("MIN_BROKER_COMMISSION");

    SettingsProxy.GetSettingsByName(optionsArray, (response) =>
      this.setState({
        discountTypes: response,
        settingKeys: optionsArray,
      })
    );
  };

  getUserById = () => {
    BrokerProxy.GetSingleBrokerById(this.props.userId, (response) =>
      this.setState({
        newusername: response.username,
        newUserType: {
          value: response.usertype,
          label: response.usertype,
        },
        newfirst_name: response.first_name,
        newmiddle_name: response.middle_name,
        newlast_name: response.last_name,
        newdesignation: response.designation,
        newemployeeid: response.employeeid,
        newlocationid: response.locationid,
        newfullLocation: {
          value: response.locationid,
          label: response.location + " | " + response.country,
        },
        newAssignedEmployee: setPropSourceDataofEmployee(
          response.employebrokerdtos
        ),
        newAssignedCustomer: setPropSourceDataofCustomer(
          response.brokercustomerdtos
        ),
        newGrade:
          response !== null && response !== undefined && response.grade !== null
            ? { value: response.grade, label: response.grade }
            : { value: "", label: "error" },
        newDiscount:
          response !== null &&
            response !== undefined &&
            response.discount !== null
            ? response.discount
            : "",
        newCommission:
          response !== null &&
            response !== undefined &&
            response.commission !== null
            ? response.commission
            : "",
        newGstNo:
          response !== null &&
            response !== undefined &&
            response.gstinno !== null
            ? response.gstinno
            : "",
        newspecialuser: response.specialuser,
        newPanNo:
          response !== null && response !== undefined && response.panno !== null
            ? response.panno
            : "",
        newdeleted: response.deleted,
        newdisabled: response.disabled,
        newEmail: response.email,
        newPhone: response.phone,
        newCreated: response.created,
        newCreatedBy: response.createdby,
        newCompanyName: response.companyname,
        newLabGrownDiscount: response !== null &&
          response !== undefined &&
          response.labgrowndiscount !== null
          ? response.labgrowndiscount
          : "",
        newLabGrownCommission: response !== null &&
          response !== undefined &&
          response.labgrowncommission !== null
          ? response.labgrowncommission
          : "",
      })
    );
  };

  getAllEmployee = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showEmployeeLoadSpinner: true });
    UserProxy.GetAllEmployeeMini("", (response) =>
      this.setAllEmployeeData(response)
    );
  };

  setAllEmployeeData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.username };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      employeeOptions: optionsArray,
      newAssignedEmployee:
        this.state.newAssignedEmployee === "" && optionsArray.length > 0
          ? optionsArray[0]
          : this.state.newAssignedEmployee,
      showEmployeeLoadSpinner: false,
    });
  };
  getAllCustomer = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showCustomerLoadSpinner: true });
    UserProxy.GetAllCustomerMini((response) =>
      this.setAllCustomerData(response)
    );
  };

  setAllCustomerData = (response) => {
    const sortedResponse = Utility.sortFn(response, "username");
    let optionsArray = [];
    sortedResponse.map((data) => {
      let option = { value: data.id, label: data.username };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      customerOptions: optionsArray,
      newAssignedCustomer:
        this.state.newAssignedCustomer === "" && optionsArray.length > 0
          ? optionsArray[0]
          : this.state.newAssignedCustomer,
      showCustomerLoadSpinner: false,
    });
  };

  getAllLocationList = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showLocationLoadSpinner: true });
    LocationProxy.GetAllLocationDetail((response) =>
      this.setAllLocationData(response)
    );
  };

  setAllLocationData = (response) => {
    this.setAllGrades();
    let cOptions = [];
    let nnewfullLocation = this.state.newfullLocation;
    response.map((data) => {
      let iOption = {
        value: data.id,
        label: data.name + " | " + data.country,
      };
      cOptions.push(iOption);

      if (data.id === this.state.newfullLocation.value)
        nnewfullLocation = iOption;
      return true;
    });

    //During new creation option select first one as default
    if (nnewfullLocation.value === 0 && cOptions.length > 0)
      nnewfullLocation = cOptions[0];

    this.setState({
      fullLocation: response,
      fullLocationOptions: cOptions,
      newfullLocation: nnewfullLocation,
      showLocationLoadSpinner: false,
    });
  };

  getAllDesignationList = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showDesignationLoadSpinner: true });
    DesignationProxy.GetAllDesignation((response) =>
      this.setAllDesigationData(response)
    );
  };

  setAllDesigationData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.name, label: data.name };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      designationOptions: optionsArray,
      newdesignation:
        this.state.newdesignation === "" && optionsArray.length > 0
          ? optionsArray[0].value
          : this.state.newdesignation,
      showDesignationLoadSpinner: false,
    });
  };

  setAllGrades = () => {
    let optionsArray = [];
    Constants.GRADES.map((grade) => {
      let option = { value: grade, label: grade };
      optionsArray.push(option);
      return true;
    });
    this.setState({
      allGrades: optionsArray,
      newGrade:
        this.state.newGrade.value === 0 && optionsArray.length > 0
          ? optionsArray[2]
          : this.state.newGrade,
    });
  };

  handleSave = () => {
    let brokerId =
      this.props.sourceData === undefined
        ? this.props.userId
        : this.props.sourceData.id;
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      username: this.state.newusername,
      first_name: this.state.newfirst_name,
      middle_name: this.state.newmiddle_name,
      last_name: this.state.newlast_name,
      designation: this.state.newdesignation,
      employeeid: this.state.newemployeeid,
      employebrokerdtos: fullOptionToEmployeeValue(
        brokerId,
        this.state.newAssignedEmployee
      ),
      brokercustomerdtos: fullOptionToCustomerValue(
        brokerId,
        this.state.newAssignedCustomer
      ),
      locationid: this.state.newfullLocation.value,
      deleted: this.state.newdeleted,
      disabled: this.state.newdisabled,
      grade: this.state.newGrade.value,
      discount: this.state.newDiscount,
      commission: !this.state.newCommission ? 0 : this.state.newCommission,
      labgrowncommission: this.state.newLabGrownCommission,
      labgrowndiscount: this.state.newLabgrownDiscount,
      gstinno: this.state.newGstNo,
      specialuser: this.state.newspecialuser,
      panno: this.state.newPanNo,
      usertype: this.state.newUserType.value,
      email: this.state.newEmail,
      phone: this.state.newPhone,
      created: this.state.newCreated,
      companyname: this.state.newCompanyName,
      createdby: this.state.newCreatedBy,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(brokerId, data))
          this.props.handleSave(brokerId, data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(brokerId, data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  buttonDisable = () => {
    if (this.props.editOperation && this.state.newfirst_name.length === 0)
      return true;

    if (
      this.props.sourceData === undefined &&
      this.state.newfirst_name.length === 0
    )
      return true;

    if (this.state.newPanNo === "" && this.state.newPanNoValidationError.length > 0) return true;

    if (this.state.commissionValidationError.length > 0 || this.state.labgrownCommissionValidationError.length > 0) return true;

    return false;
  };

  userTypeChangeHandler = (selectedOption, type) => {
    const limits = {
      C: {
        MAX: "MAX_CUSTOMER_DISCOUNT",
        MIN: "MAX_CUSTOMER_PREMIUM",
      },
      BROKER: {
        MAX: "MAX_BROKER_COMMISSION",
        MIN: "MIN_BROKER_COMMISSION",
      },
      B: {
        MAX: "MAX_BROKER_COMMISSION",
        MIN: "MIN_BROKER_COMMISSION",
      }
    };

    const { MAX, MIN } = limits[selectedOption.label] || {};

    let MIN_MAX_LIMIT = [];
    if (MAX && MIN && this.state.settingKeys.includes(MAX) && this.state.settingKeys.includes(MIN)) {
      MIN_MAX_LIMIT = this.state.discountTypes.filter(iTypes =>
        iTypes.settingkey === MAX || iTypes.settingkey === MIN
      );
    }

    const getLimitValue = (key) => {
      const limit = MIN_MAX_LIMIT.find(iTypes => iTypes.settingkey === key);
      return limit ? limit.settingvalue : "0.0";
    };

    const MAX_LIMIT_VALUE = getLimitValue(MAX);
    const MIN_LIMIT_VALUE = getLimitValue(MIN);

    const naturalCommonState = {
      newUserType: selectedOption,
      newCommission: "0.0",
      commissionValidationError: "",
    };

    const labgrownCommonState = {
      newUserType: selectedOption,
      newLabGrownCommission: "0.0",
      labgrownCommissionValidationError: "",
    };

    if (type === "natural") {
      this.setState({
        ...naturalCommonState,
        commissionPremiumLimit: MIN_LIMIT_VALUE,
        commissionLimit: MAX_LIMIT_VALUE,
        commissionPremiumError: `You are not allowed to assign commission less than ${MIN_LIMIT_VALUE}`,
        commissionError: `You are not allowed to assign commission greater than ${MAX_LIMIT_VALUE}`
      });
    } else if (type === "labgrown") {
      this.setState({
        ...labgrownCommonState,
        commissionPremiumLimit: MIN_LIMIT_VALUE,
        commissionLimit: MAX_LIMIT_VALUE,
        labgrownCommissionPremiumError: `You are not allowed to assign commission less than ${MIN_LIMIT_VALUE}`,
        labgrownCommissionError: `You are not allowed to assign commission greater than ${MAX_LIMIT_VALUE}`
      });
    }
  };

  setCommissionError = (e, type) => {
    if (
      !e.target.value.length ||
      e.target.value === undefined ||
      e.target.value === null
    ) {
      return "";
    }

    if (type === "natural") {
      if (Utility.CheckisNumberPositive(parseFloat(e.target.value))) {
        if (parseFloat(e.target.value) > parseFloat(this.state.commissionLimit)) {
          return this.state.commissionError;
        }
      }

      if (Utility.CheckisNumberNegative(parseFloat(e.target.value))) {
        if (parseFloat(e.target.value) < parseFloat(this.state.commissionPremiumLimit)) {
          return this.state.commissionPremiumError;
        }
      }
    } else if (type === "labgrown") {
      if (Utility.CheckisNumberPositive(parseFloat(e.target.value))) {
        if (parseFloat(e.target.value) > parseFloat(this.state.commissionLimit)) {
          return this.state.labgrownCommissionError;
        }
      }

      if (Utility.CheckisNumberNegative(parseFloat(e.target.value))) {
        if (parseFloat(e.target.value) < parseFloat(this.state.commissionPremiumLimit)) {
          return this.state.labgrownCommissionPremiumError;
        }
      }
    }

    return "";
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add customer validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        {this.state.showUserDetailModal && (
          <>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                backdropFilter: "blur(1px)",
                zIndex: 1299,
              }}
            />
            <UserDetailModal
              show={true}
              handleClose={() => this.setState({ showUserDetailModal: false })}
              handleSelect={(selectedOption) => {
                if (this.state.userDetailContext === "E") {
                  const selectedData = this.state.employeeOptions.filter(opt => selectedOption.includes(opt.value));
                  this.setState({
                    userDetailContext: "",
                    showUserDetailModal: false,
                    newAssignedEmployee: selectedData,
                  });
                } else if (this.state.userDetailContext === "C") {
                  const selectedData = this.state.customerOptions.filter(opt => selectedOption.includes(opt.value));
                  this.setState({
                    userDetailContext: "",
                    showUserDetailModal: false,
                    newAssignedCustomer: selectedData,
                  });
                }
              }}
              userids={this.state.userDetailContext === "E" ?
                (this.state.employeeOptions.filter(opt => opt.value !== "*")).map(cust => cust.value) :
                (this.state.customerOptions.filter(opt => opt.value !== "*")).map(cust => cust.value)}
              selectedIds={
                this.state.userDetailContext === "E"
                  ? this.state.newAssignedEmployee.length > 0 ? this.state.newAssignedEmployee.map(i => i.value) : []
                  : this.state.newAssignedCustomer.length > 0 ? this.state.newAssignedCustomer.map(i => i.value) : []
              }
              usertype={this.state.userDetailContext}
              loading={this.state.showUserDetailModal}
              isMulti={true}
            />
          </>
        )}

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} size="lg" enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;Edit Broker
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Box
              sx={{
                width: "100%",
                "& .css-2vawn2-MuiTypography-root": {
                  alignSelf: "center",
                },
              }}
            >
              {this.props.editOperation && (
                <Box sx={{ display: "flex", width: "100%" }}>
                  <Typography sx={{ width: "24%" }}>User Id</Typography>
                  <Typography sx={{ fontWeight: "bold" }}>
                    {this.props.sourceData.id}
                  </Typography>
                </Box>
              )}
              {!this.props.sourceData && (
                <Box sx={{ display: "flex", width: "100%" }}>
                  <Typography sx={{ width: "24%" }}>User Id</Typography>
                  <Typography sx={{ fontWeight: "bold" }}>
                    {this.props.userId}
                  </Typography>
                </Box>
              )}
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "24%" }}>Username</Typography>
                <Typography sx={{ fontWeight: "bold" }}>
                  {this.state.newusername}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ width: "30%" }}>
                  First Name <sup style={{ color: "red" }}>*</sup>
                </Typography>
                <TextField
                  margin="normal"
                  size="small"
                  fullWidth
                  label="First Name (required)"
                  placeholder="Enter First Name"
                  value={this.state.newfirst_name}
                  onChange={(e) =>
                    this.setState({
                      newfirst_name: e.target.value.trim(),
                      firstNameValidationError: Utility.CheckIsPresent(
                        e.target.value
                      )
                        ? ""
                        : "First Name Cannot be Empty ",
                    })
                  }
                  helperText={this.state.firstNameValidationError}
                  error={this.state.firstNameValidationError.length > 0}
                />
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ width: "30%" }}>Middle Name</Typography>
                <TextField
                  margin="normal"
                  size="small"
                  fullWidth
                  label="Middle Name"
                  placeholder="Enter Middle Name"
                  value={this.state.newmiddle_name}
                  onChange={(e) =>
                    this.setState({
                      newmiddle_name: e.target.value.trim(),
                    })
                  }
                />
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ width: "30%" }}>Last Name</Typography>
                <TextField
                  margin="normal"
                  size="small"
                  fullWidth
                  label="Last Name"
                  placeholder="Enter Last Name"
                  value={this.state.newlast_name}
                  onChange={(e) =>
                    this.setState({
                      newlast_name: e.target.value.trim(),
                    })
                  }
                />
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "24%", alignSelf: "center" }}>
                  User Type
                </Typography>
                <Typography sx={{ fontWeight: "600" }}>
                  {Constants.USER_TYPE[this.state.newUserType.value]}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "24%", alignSelf: "center" }}>
                  Grade
                </Typography>
                <Box sx={{ width: "77%", mb: 1 }}>
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    value={this.state.allGrades.find(
                      (grade) => grade.value === this.state.newGrade.value
                    )}
                    isSearchable={true}
                    name="Grades"
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                    options={this.state.allGrades}
                    onChange={(selectedOption) =>
                      this.setState({ newGrade: selectedOption })
                    }
                    isDisabled={
                      !this.props.sourceData
                        ? this.props.userId === Constants.loggedInUser.id
                        : this.props.sourceData.id === Constants.loggedInUser.id
                    }
                  />
                </Box>
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "24%", alignSelf: "center" }}>
                  Designation
                </Typography>
                <Box sx={{ width: "76%", mb: 1 }}>
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    value={this.state.designationOptions.find(
                      (iDesig) => iDesig.value === this.state.newdesignation
                    )}
                    isSearchable={true}
                    name="Designation"
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                    options={this.state.designationOptions}
                    onChange={(selectedOption) =>
                      this.setState({
                        newdesignation: selectedOption.value,
                      })
                    }
                  />
                </Box>
                {this.state.showDesignationLoadSpinner ? (
                  <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                ) : (
                  <Tooltip title="Reload">
                    <RefreshOutlinedIcon
                      color="primary"
                      fontSize="medium"
                      onClick={() => this.getAllDesignationList(true)}
                      sx={{ cursor: "pointer", mt: 1 }}
                    />
                  </Tooltip>
                )}
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "30%" }}>Employee Id</Typography>
                <TextField
                  size="small"
                  fullWidth
                  label="Employee Id"
                  placeholder="Enter Employee Id"
                  value={this.state.newemployeeid}
                  onChange={(e) =>
                    this.setState({
                      newemployeeid: e.target.value,
                    })
                  }
                />
              </Box>
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "23%", alignSelf: "center" }}>
                  Assigned Employee
                </Typography>
                <Box sx={{ width: "76%", display: "flex", alignItems: "center" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <MultiSelect
                      options={this.state.employeeOptions}
                      value={this.state.newAssignedEmployee}
                      onChange={(e) => this.setState({ newAssignedEmployee: e })}
                      label={"All Employees"}
                    />
                  </Box>
                  <Tooltip title="View More Data">
                    <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                      <OpenInNewIcon
                        fontSize="medium"
                        onClick={() => this.setState({ showUserDetailModal: true, userDetailContext: "E" })}
                        color="action"
                      />
                    </span>
                  </Tooltip>
                  {this.state.showEmployeeLoadSpinner ? (
                    <CircularProgress size="1em" sx={{ mt: "3px", ml: 0.7 }} />
                  ) : (
                    <Tooltip title="Reload">
                      <RefreshOutlinedIcon
                        color="primary"
                        fontSize="medium"
                        onClick={() => this.getAllEmployee(true)}
                        sx={{ cursor: "pointer", mt: 1 }}
                      />
                    </Tooltip>
                  )}
                </Box>
              </Box>
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "23%", alignSelf: "center" }}>
                  Assigned Customer
                </Typography>
                <Box sx={{ width: "76%", display: "flex", alignItems: "center" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Select menuPlacement="auto"
                      blurInputOnSelect={false}
                      className="basic-single"
                      classNamePrefix="select"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      value={this.state.newAssignedCustomer}
                      isSearchable={true}
                      isMulti
                      closeMenuOnSelect={false}
                      name="All Customers"
                      menuPortalTarget={document.body}
                      styles={Constants.Styles}
                      options={this.getFilteredUserOptions(this.state.debouncedCustomerInputValue)}
                      onChange={(e) => this.setState({ newAssignedCustomer: e })}
                      inputValue={this.state.customerInputValue}
                      onInputChange={(inputValue) => this.setState({ customerInputValue: inputValue })}
                    />
                  </Box>
                  <Tooltip title="View More Data">
                    <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                      <OpenInNewIcon
                        fontSize="medium"
                        onClick={() => this.setState({ showUserDetailModal: true, userDetailContext: "C" })}
                        color="action"
                      />
                    </span>
                  </Tooltip>
                  {this.state.showCustomerLoadSpinner ? (
                    <CircularProgress size="1em" sx={{ mt: "3px", ml: 0.7 }} />
                  ) : (
                    <Tooltip title="Reload">
                      <RefreshOutlinedIcon
                        color="primary"
                        fontSize="medium"
                        onClick={() => this.getAllCustomer(true)}
                        sx={{ cursor: "pointer", mt: 1 }}
                      />
                    </Tooltip>
                  )}
                </Box>
              </Box>
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "24%", alignSelf: "center" }}>
                  Location
                </Typography>

                <Box sx={{ width: "76%" }}>
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    value={this.state.newfullLocation}
                    isSearchable={true}
                    name="Location"
                    options={this.state.fullLocationOptions}
                    onChange={(selectedOption) =>
                      this.setState({
                        newfullLocation: selectedOption,
                      })
                    }
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                  />
                </Box>

                {this.state.showLocationLoadSpinner ? (
                  <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                ) : (
                  <Tooltip title="Reload">
                    <RefreshOutlinedIcon
                      color="primary"
                      fontSize="medium"
                      onClick={() => this.getAllLocationList(true)}
                      sx={{ cursor: "pointer", mt: 1 }}
                    />
                  </Tooltip>
                )}
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "30%" }}>Commission</Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  label="Commission"
                  placeholder="Enter Commission"
                  value={this.state.newCommission}
                  onChange={(e) => {
                    this.userTypeChangeHandler(this.state.newUserType, "natural");
                    this.setState({
                      newCommission: e.target.value,
                      commissionValidationError: this.setCommissionError(e, "natural")
                    });
                  }}
                  helperText={this.state.commissionValidationError}
                  error={this.state.commissionValidationError.length > 0}
                  disabled={this.state.newUserType.value === "E"}
                />
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "30%" }}>LabGrown Commission</Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  label="Labgrown Commission"
                  placeholder="Enter Labgrown Commission"
                  value={this.state.newLabGrownCommission}
                  onChange={(e) => {
                    this.userTypeChangeHandler(this.state.newUserType, "labgrown");
                    this.setState({
                      newLabGrownCommission: e.target.value,
                      labgrownCommissionValidationError: this.setCommissionError(e, "labgrown")
                    });
                  }}
                  helperText={this.state.labgrownCommissionValidationError}
                  error={this.state.labgrownCommissionValidationError.length > 0}
                  disabled={this.state.newUserType.value === "E"}
                />
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "30%" }}>GSTIN</Typography>
                <TextField
                  fullWidth
                  size="small"
                  label="Gst No"
                  placeholder="Enter Gst number"
                  value={this.state.newGstNo}
                  onChange={(e) => {
                    this.setState({
                      newGstNo: e.target.value.replace(/[^\w\s]/gi, ""),
                    });
                  }}
                  disabled={this.state.newUserType.value === "E"}
                />
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "30%" }}>PAN</Typography>
                <TextField
                  fullWidth
                  size="small"
                  label="Pan No"
                  placeholder="Enter Pan number"
                  value={this.state.newPanNo}
                  onChange={(e) => {
                    this.setState({
                      newPanNo: e.target.value.trim(),
                      newPanNoValidationError: e.target.value
                        ? "" : "Pan No can't be Empty",
                    });
                  }}
                  disabled={this.state.newUserType.value === "E"}
                  helperText={this.state.newPanNoValidationError}
                  error={this.state.newPanNoValidationError.length > 0}
                />
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Box sx={{ width: "24%" }}></Box>
                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.newdeleted}
                        onChange={(e) =>
                          this.setState({
                            newdeleted: !this.state.newdeleted,
                          })
                        }
                      />
                    }
                    label="Deleted"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "0.8rem",
                      },
                    }}
                  />
                </Box>
                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.newdisabled}
                        onChange={(e) =>
                          this.setState({
                            newdisabled: !this.state.newdisabled,
                          })
                        }
                      />
                    }
                    label="Disabled"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "0.8rem",
                      },
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Modal.Body>
          <Modal.Footer>
            {this.props.saveButton ? (
              <LoadingButton
                variant="contained"
                loading={this.props.loading}
                loadingPosition="start"
                startIcon={<SaveIcon />}
                onClick={() => this.handleSave()}
                disabled={this.buttonDisable()}
                sx={{ mr: 1 }}
              >
                Save
              </LoadingButton>
            ) : null}
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
